import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  ad_root: {
    width: '100%',
    height: '100vh',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: '32px 86px 1fr',
  },
  tr_root: {
    width: '100%',
    paddingTop: '28px',
    paddingBottom: '28px',
  },
  sh_root: {
    width: '100%',
    backgroundColor: 'white',
    paddingTop: '9px',
    paddingBottom: '9px',
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    display: 'flex',
    alignItems: 'center',
  },
  sh_label: {
    fontSize: 12,
    fontWeight: 600,
    paddingRight: 14,
    color: theme.palette.grey[600],
  },
  ct_root: {
    width: '100%',
    paddingBottom: '28px',
    borderTop: `1px solid ${theme.palette.grey[200]}`,
  },
  rn_root: {
    width: '100%',
    padding: theme.spacing(5),
  },
  acc_root: {
    width: '100%',
    padding: '28px 40px',
  },
  nav_root: {
    width: '100%',
    background: `#fff`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
  },
  nav_title_container: {
    display: 'flex',
    flexDirection: 'column',
    paddingRight: theme.spacing(6),
  },
  nav_title: {
    fontSize: '21px',
    fontWeight: 'bold',
    margin: 0,
    color: theme.palette.grey[800],
  },
  nav_title_caption: {
    fontSize: '12px',
    margin: 0,
    color: theme.palette.grey[500],
  },
  nav_navigation_list: {
    display: 'flex',
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  nav_navigation_item: {
    fontSize: 14,
    fontWeight: 600,
    padding: theme.spacing(2),
    cursor: 'pointer',
    color: theme.palette.grey[800],
    transition: 'all 0.3s ease-out',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  acl_button: {
    textTransform: 'none',
    display: 'flex',
    boxShadow: `0px 2px 7px rgba(107, 114, 128, 0.15)`,
  },
  rn_select_container: {
    width: '100%',
    height: '100%',
    display: 'flex',

    justifyContent: 'space-between',
  },
  rn_selects_left_side: {
    display: 'flex',
    flex: 1,
    height: '100%',
  },
  secondary_button: {
    backgroundColor: theme.palette.grey[200],
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.grey[300],
    },
  },
}));

export default useStyles;
